import { Component, ElementRef, OnInit, Input } from '@angular/core';

import { LoginService } from '../../../../../../shared/services/auth/login/login.service';

import * as md5 from 'blueimp-md5';

@Component({
  selector: 'app-card-alterar-senha',
  templateUrl: './card-alterar-senha.component.html',
  styleUrls: ['./card-alterar-senha.component.scss']
})
export class CardAlterarSenhaComponent implements OnInit {
  @Input() private conta: any;

  public msgPasswordError = false;
  public msgPasswordSuccess = false;
  public msgInvalidPassword = false;

  public hasOneNumber = false;
  public hasOneLowercase = false;
  public hasOneUppercase = false;
  public hasEightCharacters = false;
  public hasOneSpecialCharacter = false;

  public novaSenha = '';
  public senhaAtual = '';
  public confirmarNovaSenha = '';

  constructor(
    private elRef: ElementRef,
    private loginService: LoginService,
  ) { }

  ngOnInit() {

  }

  keyupPassword(e) {
    switch (e.target.id) {
      case 'newPassword':
        this.verifyPasswordStreight();
        break;
    }
  }

  isInputsValid(target?) {
    if (!target) {
      const inputs: any = this.elRef.nativeElement.querySelectorAll('.card-password' +
                                                                    'input[type="password"], ' +
                                                                    '.card-password ' +
                                                                    'input[type="text"]');

      let hasInputsEmpty = false;
      inputs.forEach((input) => {
        if (input.value.length === 0) {
          input.parentNode.classList.add('has-error');
          hasInputsEmpty = true;
        }
      });

      if (hasInputsEmpty) {
        return false;
      }

      if (this.novaSenha !== this.confirmarNovaSenha) {
        this.elRef.nativeElement.querySelector('#newPassword').parentNode.parentNode.classList.add('has-error');
        this.elRef.nativeElement.querySelector('#confirmNewPassword').parentNode.parentNode.classList.add('has-error');
        return false;
      }

      if (
        !this.hasOneNumber ||
        !this.hasOneUppercase ||
        !this.hasOneLowercase ||
        !this.hasEightCharacters ||
        !this.hasOneSpecialCharacter
      ) {
        this.elRef.nativeElement.querySelector('#newPassword').parentNode.parentNode.classList.add('has-error');
        this.elRef.nativeElement.querySelector('#confirmNewPassword').parentNode.parentNode.classList.add('has-error');
        return false;
      }

      inputs.forEach((input) => {
        if (input.value.length === 0) {
          input.parentNode.classList.remove('has-error');
        }
      });

      return true;
    }
  }

  focusInputPassword(e) {
    this.msgPasswordSuccess = false;
    this.msgPasswordError = false;

    e.target.parentNode.classList.remove('has-error');
  }

  verifyPasswordStreight() {
    this.hasOneNumber = this.hasNumber() ? true : false;
    this.hasOneUppercase = this.hasUpperCase() ? true : false;
    this.hasOneLowercase = this.hasLowerCase() ? true : false;
    this.hasEightCharacters = this.hasEigthCharacters() ? true : false;
    this.hasOneSpecialCharacter = this.hasSpecialCharacter() ? true : false;
  }

  hasEigthCharacters() {
    return this.novaSenha.length >= 8 ? true : false;
  }

  hasUpperCase() {
    const numUpper = this.novaSenha.length - this.novaSenha.replace(/[A-Z]/g, '').length;
    return numUpper > 0 ? true : false;
  }

  hasLowerCase() {
    const numLower = this.novaSenha.length - this.novaSenha.replace(/[a-z]/g, '').length;
    return numLower > 0 ? true : false;
  }

  hasNumber() {
    const numbers = this.novaSenha.length - this.novaSenha.replace(/[0-9]/g, '').length;
    return numbers > 0 ? true : false;
  }

  hasSpecialCharacter() {
    const specials = this.novaSenha.length - this.novaSenha.replace(/[!@#$%^&*()_+\-=\[\]{};':'\\|,.<>\/?]+/g, '').length;
    return specials > 0 ? true : false;
  }

  showCharacters(e) {
    const inputs = this.elRef.nativeElement.querySelectorAll('.card-password input');
    if (e.target.checked) {
      inputs.forEach((input) => {
        if (input.type === 'password') {
          input.type = 'text';
        }
      });
    } else {
      inputs.forEach(() => {
        inputs.forEach((input) => {
          if (input.type === 'text') {
            input.type = 'password';
          }
        });
      });
    }
  }

  alterarSenha(e) {
    e.preventDefault();

    if (!this.isInputsValid()) {
      return;
    }

    this.elRef.nativeElement.querySelector('#submit-senha').classList.add('loading');

    const data = {
      Email: this.conta.Email,
      OldPassword: md5(this.conta.Email.toLowerCase() + this.senhaAtual),
      NewPassword: md5(this.conta.Email.toLowerCase() + this.novaSenha),
    };

    this.loginService.changePassword(data).subscribe(() => {
      this.msgPasswordSuccess = true;
      this.msgPasswordError = false;
      this.msgInvalidPassword = false;

      this.elRef.nativeElement.querySelector('#submit-senha').classList.remove('loading');
    }, (err) => {
      this.msgPasswordSuccess = false;

      if (err && err.error && err.error.ModelState && err.error.ModelState[''] && err.error.ModelState[''].length > 0) {
        const self = this;
        err.error.ModelState[''].forEach((error) => {
          if (error === 'Incorrect password.') {
            self.msgInvalidPassword = true;
            self.msgPasswordError = false;

            this.elRef.nativeElement.querySelector('#password').parentNode.parentNode.classList.add('has-error');
          }
        });
      } else {
        this.msgPasswordError = true;
      }

      console.error(err);
      this.elRef.nativeElement.querySelector('#submit-senha').classList.remove('loading');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/minha-conta/configuracoes/card-alterar-senha/card-alterar-senha.component.ts